import { City } from "./city";

export class Organization {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    name!: string;
    name_en!: string;
    name_ka!: string;
    name_ru!: string;
    hourly_salary_title!: string;
    hourly_salary_id!: string;
    hourly_invoicable_title!: string;
    hourly_invoicable_id!: string
    customer_shifts_editable_after!: number;
    customer_shifts_not_editable_before!: number;
    employee_shifts_editable_after!: number;
    street_address!: string;
    office!: string;
    city!: string;
    postal_code!: string;
    lat!: string;
    long!: string;
    tbc_api_key!: string;
    tbc_client_id!: string;
    tbc_api_secret!: string;
    checkin_warnings_user_id!: number;
    new_customer_allow_ordering_with_cash!: boolean
    new_customer_allow_ordering_with_invoice!: boolean
    default_km_expense!: number
    reserve_grace_period!: number
    customer_order_start_time!: string
    customer_order_end_time!: string
    customer_order_step!: number
    minimum_order!: number
    customer_tnc!: string
    customer_public_greeting_en!: string
    customer_public_greeting_ka!: string
    customer_public_greeting_ru!: string
    homepage!: string
    phone!: string
    email!: string
    company_id!: string
    allow_public_ordering!: boolean
    customer_order_margin!: number
    customer_order_monday!: boolean
    customer_order_tuesday!: boolean
    customer_order_wednesday!: boolean
    customer_order_thursday!: boolean 
    customer_order_friday!: boolean
    customer_order_saturday!: boolean
    customer_order_sunday!: boolean
    disable_card_payments!: boolean
    secondary_phone!: string
    payment_api!: string
    currency!: string
    country_code!: string
    country!: string
    cities: City[] = []
    api_url!: string
    ws_url!: string
    customer_public_greeting_title!: string
    discount_weekly!: number
    discount_biweekly!: number
    discount_quadweekly!: number
    languages!: string
    customer_facebook_link!: string
    customer_facebook_link_en!: string
    customer_facebook_link_ar!: string
    customer_facebook_link_et!: string
    customer_facebook_link_fi!: string
    customer_facebook_link_lv!: string
    customer_facebook_link_lt!: string
    customer_facebook_link_ru!: string
    customer_facebook_link_sv!: string
    customer_x_link!: string
    customer_x_link_en!: string
    customer_x_link_ar!: string
    customer_x_link_et!: string
    customer_x_link_fi!: string
    customer_x_link_lv!: string
    customer_x_link_lt!: string
    customer_x_link_ru!: string
    customer_x_link_sv!: string
    customer_youtube_link!: string
    customer_youtube_link_en!: string
    customer_youtube_link_ar!: string
    customer_youtube_link_et!: string
    customer_youtube_link_fi!: string
    customer_youtube_link_lv!: string
    customer_youtube_link_lt!: string
    customer_youtube_link_ru!: string
    customer_youtube_link_sv!: string
}
